import { isNil } from '@flex-design-system/fx-utils/common';
import { composeEventHandlers } from '@radix-ui/primitive';
import { useRef, useState, useEffect } from 'react';
import { logger } from '../../../utils/logger.mjs';

function useInputValue({
  value: _value,
  defaultValue,
  onChange: _onChange
}) {
  const ref = useRef(_value !== void 0);
  const wasControlled = ref.current;
  const isControlled = _value !== void 0;
  if (wasControlled !== isControlled) {
    logger.warn(
      `${wasControlled ? "controlled" : "uncontrolled"} \uC5D0\uC11C ${isControlled ? "controlled" : "uncontrolled"}\uB85C \uBCC0\uACBD\uB418\uC5C8\uC2B5\uB2C8\uB2E4. defaultValue / value prop\uC911 \uD558\uB098\uB9CC \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694.`
    );
  }
  const [value, setValue] = useState(_value ?? defaultValue ?? "");
  useEffect(() => {
    const isControllable = !isNil(_value);
    if (isControllable) {
      setValue(_value);
    }
  }, [_value]);
  const onChange = composeEventHandlers(
    _onChange,
    (e) => setValue(e.target.value)
  );
  return [value, onChange];
}

export { useInputValue as default };
//# sourceMappingURL=useInputValue.mjs.map
